import type { ChangeCatalogKindItem } from '../../types/changes';

/**
 * Espelho do `list_registry()` do backend. O hub busca a API; isto cobre
 * fallback e os testes de contrato das abas.
 *
 * Cadastro simples novo: incluir a spec no BE e uma linha aqui.
 * Cadastro com forma própria: spec especial no BE + painel no hub.
 * Menu agrupado: incluir o `tab` em `CHANGE_CATALOG_NAV_GROUPS`.
 */
export const CHANGE_CATALOG_REGISTRY: ChangeCatalogKindItem[] = [
  {
    slug: 'categories',
    kind: 'simple',
    label: 'categoria',
    plural_label: 'categorias',
    title: 'Categorias de mudança',
    description: 'Opções do campo Categoria no formulário de mudança.',
    path: '/categories',
    tab: 'categories',
  },
  {
    slug: 'requester-areas',
    kind: 'simple',
    label: 'área solicitante',
    plural_label: 'áreas solicitantes',
    title: 'Áreas solicitantes',
    description: 'Opções do campo Área solicitante no formulário de mudança.',
    path: '/requester-areas',
    tab: 'requester-areas',
  },
  {
    slug: 'task-types',
    kind: 'simple',
    label: 'tipo de tarefa',
    plural_label: 'tipos de tarefa',
    title: 'Tipos de tarefa',
    description:
      'Opções do campo Tipo da tarefa na subtarefa. Dá para criar, editar, renomear e desativar.',
    path: '/task-types',
    tab: 'task-types',
  },
  {
    slug: 'change-types',
    kind: 'change_types',
    label: 'tipo de mudança',
    plural_label: 'tipos de mudança',
    title: 'Tipos de mudança',
    description:
      'Para cada tipo: ligar checklists internas (SupportNect) e/ou chamados no Incidente. Correção e Emergencial vêm com internas desligadas; você pode alterar.',
    path: '/change-types',
    tab: 'change-types',
  },
  {
    slug: 'work-groups',
    kind: 'work_groups',
    label: 'grupo',
    plural_label: 'grupos',
    title: 'Grupos',
    description: 'Grupos só deste módulo: recebem subtarefa, perguntas do checklist e slot de aprovação.',
    path: '/work-groups',
    tab: 'work-groups',
  },
  {
    slug: 'internal-subtask-templates',
    kind: 'internal_subtask_templates',
    label: 'subtarefa interna',
    plural_label: 'subtarefas internas',
    title: 'Subtarefas internas',
    description:
      'Crie a subtarefa interna com campos customizados. Em Grupos, vincule e ligue o disparo na criação.',
    path: '/internal-subtask-templates',
    tab: 'internal-subtask-templates',
  },
  {
    slug: 'approval-settings',
    kind: 'approval_settings',
    label: 'aprovações de comitê',
    plural_label: 'aprovações de comitê',
    title: 'Aprovações de comitê',
    description:
      'Trilhas do comitê no status Autorizar (CAMUD, Riscos e impactos, Gestor de mudanças) e quem pode montar o plano em Quem aprova esta mudança. Áreas como CINFRA vêm de Estrutura → Grupos.',
    path: '/approval-settings',
    tab: 'approval-settings',
  },
  {
    slug: 'emergency-policy',
    kind: 'emergency_policy',
    label: 'aprovação emergencial',
    plural_label: 'aprovação emergencial',
    title: 'Aprovação emergencial',
    description: 'Gestores, áreas fixas (GTEC/GSERV-I) e a ordem da aprovação do tipo Emergencial.',
    path: '/emergency-policy',
    tab: 'emergency-policy',
  },
  {
    slug: 'sap-request-transport',
    kind: 'sap_request_transport',
    label: 'Transporte SAP (request)',
    plural_label: 'Transporte SAP (request)',
    title: 'Transporte SAP (request)',
    description:
      'Área e pessoa da aprovação extra em Transporte quando SAP e «Tem request?» = Sim.',
    path: '/sap-request-transport',
    tab: 'sap-request-transport',
  },
  {
    slug: 'approval-form',
    kind: 'approval_form',
    label: 'formulário do aprovador',
    plural_label: 'formulário do aprovador',
    title: 'Formulário do aprovador',
    description:
      'Ordem das aprovações (gestor de mudanças primeiro ou livre) e campos extras no Aprovar/Reprovar.',
    path: '/approval-form-schema',
    tab: 'approval-form',
  },
  {
    slug: 'create-form',
    kind: 'create_form',
    label: 'formulário de criação',
    plural_label: 'formulário de criação',
    title: 'Formulário de criação',
    description:
      'Ordem, largura, obrigatoriedade e campos extras da modal Nova mudança. Em datas, dá para exigir um dia da semana ou deixar livre. Arraste para reposicionar.',
    path: '/form-schema',
    tab: 'create-form',
  },
  {
    slug: 'detail-summary',
    kind: 'detail_summary',
    label: 'resumo do detalhe',
    plural_label: 'resumo do detalhe',
    title: 'Resumo do detalhe',
    description:
      'Quais campos aparecem no card superior ao abrir uma mudança, e em qual ordem. Independente do formulário de criação. Arraste para reposicionar.',
    path: '/detail-summary-schema',
    tab: 'detail-summary',
  },
  {
    slug: 'subtask-form',
    kind: 'subtask_form',
    label: 'formulário de subtarefa',
    plural_label: 'formulário de subtarefa',
    title: 'Formulário de subtarefa',
    description:
      'Campos da nova subtarefa, extras e quem pode concluir. Arraste para reposicionar.',
    path: '/subtask-form-schema',
    tab: 'subtask-form',
  },
  {
    slug: 'detail-tabs',
    kind: 'detail_tabs',
    label: 'aba da ficha',
    plural_label: 'abas da ficha',
    title: 'Abas da ficha',
    description:
      'Abas extras na ficha da mudança com registros por aba, campos configuráveis e visibilidade por status.',
    path: '/detail-tabs',
    tab: 'detail-tabs',
  },
  {
    slug: 'post-impl-form',
    kind: 'post_impl_form',
    label: 'formulário de pós-implantação',
    plural_label: 'formulário de pós-implantação',
    title: 'Formulário de pós-implantação',
    description:
      'Campos do registro pós-implantação, ordem e extras. Arraste para reposicionar.',
    path: '/post-impl-form-schema',
    tab: 'post-impl-form',
  },
  {
    slug: 'email-triggers',
    kind: 'change_email_triggers',
    label: 'e-mail',
    plural_label: 'e-mails',
    title: 'E-mail',
    description:
      'Gatilhos do ciclo de vida (criação da mudança), destinatários, layout e disparos agendados. E-mail da reunião/pauta fica em «E-mail da pauta».',
    path: '/email-triggers',
    tab: 'email-triggers',
  },
  {
    slug: 'email-queued',
    kind: 'change_email_queued',
    label: 'e-mail agendado',
    plural_label: 'e-mails agendados',
    title: 'E-mails agendados',
    description:
      'Fila de disparos marcados para o futuro: pauta da reunião e gatilhos. Enviar agora ou cancelar.',
    path: '/email-queued',
    tab: 'email-queued',
  },
  {
    slug: 'email-pauta',
    kind: 'agenda_email',
    label: 'e-mail da pauta',
    plural_label: 'e-mails da pauta',
    title: 'E-mail da pauta',
    description:
      'Layout do e-mail da reunião: ligar ou desligar, título, descrição e anexo da lista de mudanças. No calendário e no CAB, «Escrever e-mail» puxa este texto e preenche as N mudanças desta reunião.',
    path: '/email-pauta',
    tab: 'email-pauta',
  },
  {
    slug: 'committees',
    kind: 'committees',
    label: 'comitê',
    plural_label: 'comitês',
    title: 'Comitês',
    description: 'Quem recebe o e-mail da pauta. Independente das áreas que aprovam a mudança.',
    path: '/committees',
    tab: 'committees',
  },
  {
    slug: 'cab-slides',
    kind: 'cab_slides',
    label: 'apresentação CAB',
    plural_label: 'apresentação CAB',
    title: 'Apresentação CAB',
    description:
      'Páginas da apresentação na reunião: quais campos da mudança aparecem em cada slide e a ordem. Arraste para reposicionar.',
    path: '/cab-slides',
    tab: 'cab-slides',
  },
];

/** Grupos do menu lateral (accordion) do hub de cadastros. */
export type CatalogNavGroupId = 'estrutura' | 'aprovacoes' | 'formularios' | 'comunicacao' | 'outros';

export interface CatalogNavGroupDef {
  id: CatalogNavGroupId;
  label: string;
  tabs: string[];
}

export interface CatalogNavGroup extends CatalogNavGroupDef {
  items: ChangeCatalogKindItem[];
}

export const CHANGE_CATALOG_NAV_GROUPS: CatalogNavGroupDef[] = [
  {
    id: 'estrutura',
    label: 'Estrutura',
    tabs: [
      'categories',
      'requester-areas',
      'task-types',
      'change-types',
      'work-groups',
      'internal-subtask-templates',
    ],
  },
  {
    id: 'aprovacoes',
    label: 'Aprovações',
    tabs: ['approval-settings', 'emergency-policy', 'sap-request-transport', 'approval-form'],
  },
  {
    id: 'formularios',
    label: 'Formulários',
    tabs: [
      'create-form',
      'detail-summary',
      'detail-tabs',
      'subtask-form',
      'post-impl-form',
    ],
  },
  {
    id: 'comunicacao',
    label: 'Comunicação',
    tabs: ['email-triggers', 'email-queued', 'email-pauta', 'committees', 'cab-slides'],
  },
];

const KNOWN_NAV_TABS = new Set(CHANGE_CATALOG_NAV_GROUPS.flatMap((group) => group.tabs));

export function groupCatalogItemsForNav(items: ChangeCatalogKindItem[]): CatalogNavGroup[] {
  const byTab = new Map(items.map((item) => [item.tab, item]));
  const groups: CatalogNavGroup[] = CHANGE_CATALOG_NAV_GROUPS.map((group) => ({
    ...group,
    items: group.tabs
      .map((tab) => byTab.get(tab))
      .filter((item): item is ChangeCatalogKindItem => Boolean(item)),
  })).filter((group) => group.items.length > 0);

  const orphans = items.filter((item) => !KNOWN_NAV_TABS.has(item.tab));
  if (orphans.length) {
    groups.push({
      id: 'outros',
      label: 'Outros',
      tabs: orphans.map((item) => item.tab),
      items: orphans,
    });
  }
  return groups;
}

export function resolveCatalogNavGroupId(
  tab: string | undefined,
  groups: CatalogNavGroup[] = groupCatalogItemsForNav(CHANGE_CATALOG_REGISTRY),
): CatalogNavGroupId {
  if (tab) {
    const found = groups.find((group) => group.items.some((item) => item.tab === tab));
    if (found) return found.id;
  }
  return groups[0]?.id || 'estrutura';
}

export const CHANGE_CATALOGS_HUB_PATH = '/changes/cadastros';

/** URLs antigas → aba do hub. */
export const LEGACY_CATALOG_PATHS: Record<string, string> = {
  '/changes/categories': 'categories',
  '/changes/requester-areas': 'requester-areas',
  '/changes/areas': 'work-groups',
};

export function catalogHubPath(tab?: string) {
  const slug = tab || CHANGE_CATALOG_REGISTRY[0]?.tab || 'categories';
  return `${CHANGE_CATALOGS_HUB_PATH}/${slug}`;
}

export function internalSubtaskTemplatePath(templateId: number) {
  return `${catalogHubPath('internal-subtask-templates')}?id=${templateId}`;
}

export function resolveCatalogTab(tab: string | undefined, items: ChangeCatalogKindItem[]) {
  const source = items.length ? items : CHANGE_CATALOG_REGISTRY;
  if (tab === 'internal-auto-subtasks') {
    tab = 'internal-subtask-templates';
  }
  if (tab === 'subtask-requester-policy') {
    tab = 'subtask-form';
  }
  if (tab && source.some((item) => item.tab === tab)) {
    return tab;
  }
  return source[0]?.tab || 'categories';
}
